// extracted by mini-css-extract-plugin
export default {"homeTemplateCont":"HomeTemplate_homeTemplateCont__JMFvn","homeTemplate":"HomeTemplate_homeTemplate__uVeUB","main":"HomeTemplate_main__rNHKZ"};